import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ReactiveFormsModule, FormsModule } from "@angular/forms";
import { MedIconXModule, MedIconChevronDownModule } from "@mk/med-icons";

import { MedSelectComponent } from "./med-select.component";
import { MedLabelModule } from "../med-label/med-label.module";
import { MedDirectiveSharedModule } from "../../../directives/med-directive-shared.module";

@NgModule({
  declarations: [
    MedSelectComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MedLabelModule,
    MedDirectiveSharedModule,
    MedIconXModule,
    MedIconChevronDownModule,
  ],
  exports: [
    MedSelectComponent,
  ],
})
export class MedSelectModule { }
